import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MaintenanceOwnerService } from './maintenance-owner.service';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-maintenance-owner',
    templateUrl: './maintenance-owner.component.html',
    styleUrls: ['./maintenance-owner.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MaintenanceOwnerComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  // STANDARD COMPONENT PROPERTIES
  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = true;
  crudLoading = false;
  showFormLoader = false;

  // Component specific properties
  modalTitle = "MAINTENANCE OWNER";
  maintainanceOwner: any[] = [];

  // Data properties
  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  gridData: any = null;
  syncSaveDtls: any[] = [];

  // Entity data properties
  entityList: any[] = [];
  leId: string = '';
  cdr_no: string = '';
  leType: string = '';

  constructor(
    private _snackBar: MatSnackBar,
    private maintenanceOwnerService: MaintenanceOwnerService,
    private cdr: ChangeDetectorRef
  ) {}

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      let urls = safeJsonInput<any>(baseUrls, null, 'maintenance-owner.parse1');
      if (Object.keys(urls).length > 0) {
        // Handle base URLs if needed
      }
    } catch (e) {
      console.log("Base URLs input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('header-data')
  set _header_data(headerData: string) {
    try {
      let header = safeJsonInput<any>(headerData, null, 'maintenance-owner.parse2');
      if (Object.keys(header).length > 0) {
        this.globalService = header.globalParams || {};
        this.USER_SETTINGS = header.userSettingsData || {};
        this.GENERAL_CONFIG = header.generalConfigData || {};
        this.init();
      }
    } catch (e) {
      console.log("Header data input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('row-data')
  set _row_data(rowData: string) {
    try {
      let data = safeJsonInput<any>(rowData, null, 'maintenance-owner.parse3');
      if (Object.keys(data).length > 0) {
        this.rowData = data;
        this.init();
      }
    } catch (e) {
      console.log("Row data input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('filter-params')
  set _filter_params(filterParams: string) {
    try {
      let params = safeJsonInput<any>(filterParams, null, 'maintenance-owner.parse4');
      if (Object.keys(params).length > 0) {
        this.filterParams = params;
        this.init();
      }
    } catch (e) {
      console.log("Filter params input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('grid-data')
  set _grid_data(gridData: string) {
    try {
      let data = safeJsonInput<any>(gridData, null, 'maintenance-owner.parse5');
      if (data != null) {
        this.gridData = data;
        this.processGridData();
      }
    } catch (e) {
      console.log("Grid data input not yet stable. Still waiting to get resolved.");
    }
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    try {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.setupEntityData();
        this.processGridData();
      }
    } catch (e) {
      console.error('Error in MaintenanceOwner init:', e);
    }
  }

  private setupEntityData() {
    // 🔴 CRITICAL: Use REAL data from rowData - NO TEST_ values!
    this.leId = this.rowData.LEID || '';
    this.cdr_no = this.rowData.MARS || '';
    this.leType = this.rowData.LE_TYPE || '';

    // 🔴 MANDATORY ORDER: Tax Year, LEID, LE Name
    this.entityList = [
      { key: "Tax Year", value: this.rowData.TAX_YEAR || '' },
      { key: "LEID", value: this.rowData.LEID || '' },
      { key: "LE Name", value: this.rowData.LE_NAME || '' }
    ];
  }

  private processGridData() {
    if (this.gridData != null) {
      this.syncSaveDtls = [];
      
      if (this.gridData !== undefined) {
        for (let key in this.gridData) {
          let gridObj: any = {};
          gridObj["combination_key"] = this.gridData[key].data.COMBINATION_KEY;
          this.syncSaveDtls.push(gridObj);
        }
      }
    }
  }

  addNew() {
    this.isSaveClicked = false;
    this.maintainanceOwner.push({
      ID: this.maintainanceOwner.length,
      PARENT_ME_CODE: "",
      MAINTENANCE_OWNER: ""
    });
  }

  deleteRow(index: number) {
    this.maintainanceOwner.splice(index, 1);
    this.isSaveClicked = this.maintainanceOwner.length > 0 ? false : true;
  }

  save() {
    this.isSaveClicked = true;
    this.crudLoading = true;
    
    const clob_settings = [{
      sso_id: this.USER_SETTINGS?.user?.sso_id || '',
      screen_key: this.globalService?.screen_key || ''
    }];

    if(this.maintainanceOwner.length > 0) 
      {
    this.maintenanceOwnerService.saveMaintenanceOwner(
      this.GENERAL_CONFIG.base_url,
      this.maintainanceOwner,
      clob_settings,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;

        if (response.callSuccess == '1') {
          this._snackBar.open('Data added successfully', 'Close', {
            duration: 4000,
            panelClass: ['success-snackbar']
          });
          this.requestGridUpdate.emit('refresh');
        } else {
          this._snackBar.open(response.errorMessage || 'Error occurred while saving', 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
        }
      },
      (error: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this._snackBar.open('Error occurred while saving. Please try again.', 'Close', {
          duration: 4000,
          panelClass: ['error-snackbar']
        });
      }
    );
  }
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  reset() {
    this.maintainanceOwner = [];
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}


